export default {
  namespaced: true,
  state: {
    userInfo: {} , // account/login/accountLogin、 account/account/queryBaseAccoinfo、 etrade/openAcco/getDicts 接口数据
  },
  mutations: {
    setUserInfo(state, params) {
      state.userInfo = params
    },
  },
  actions: {
    getUserInfo({commit}, params) {
      commit('setUserInfo', params)
    },
  }
}
